import React from 'react';
import { Spinner } from './ui/spinner';
import { PartyPopper } from 'lucide-react';
import congresImgUrl from '@/assets/images/congres.png';

const CongresOverlay = ({ isLoading, text }: { isLoading: boolean, text: string }) => {
    if (!isLoading) return <></>;

    return (
        <>
            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="animate-fade-in flex flex-col items-center justify-center bg-green-50 rounded-4xl w-100 h-100">
                    {/* <PartyPopper className="text-violet-800 size-50"/> */}
                    <img className='w-2/3 h-2/3' src={congresImgUrl}></img>
                    <p className="text-violet-800 text-2xl">{text}</p>
                </div>
            </div>

            <div className="fixed inset-0 bg-black opacity-60 flex items-center justify-center z-40">
            </div>
        </>
    );
};

export default CongresOverlay;